<!-- titulo -->
<div class="row">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
        <h1>Administración</h1>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2 d-flex justify-content-end">
        <div>
            <button class="btn btn-secondary mr-2 mb-1" (click)="init()">
                <fa-icon [icon]="['fas','redo']"></fa-icon> Actualizar
            </button>
            <button class="btn btn-primary mb-1" (click)="collapseSearch = !collapseSearch">
                <fa-icon [icon]="['fas','search']"></fa-icon> Busqueda Avanzada
            </button>
        </div>
    </div>
</div>

<!-- busqueda avanzada -->
<div class="row collapse" [ngbCollapse]="collapseSearch" id="advanceSearch">
    <div class="col-12">
        <app-search-ficha [evaluaciones]="evaluaciones" (search)="search($event)"></app-search-ficha>
    </div>
</div>

<!-- fichas -->
<div class="row" infinite-scroll [infiniteScrollDistance]="2" (scrolled)="onScroll()">
    <div class="col">
        <div class="table-responsive">
            <table class="table table-bordered table-hover">
                <thead>
                    <th>N°</th>
                    <th scope="col" *ngFor="let item of sort.menu"
                        [ngClass]="{ 'text-primary': sort.name == item.sort }" [ngStyle]="{ cursor: 'pointer'}"
                        (click)="setOrder(item.sort)">
                        <fa-icon [icon]="iconOrder(item.sort)"></fa-icon> {{item.title}}
                    </th>
                    <th>Opciones</th>
                </thead>
                <tbody>
                    <tr *ngFor="let item of models let i=index">
                        <td>{{i+1}}</td>
                <td>{{item.fic_id}}</td>
                <td>{{item.trabajador.rut}}</td>
                <td >{{item.params.data.decCorrectos}}</td>
                <td>{{item.params.data.decTotal}}</td>
                <td style="font-weight: bold;">{{item.params.data.dec_nota}}</td>
                <td>{{item.params.data.conCorrectos}}</td>
                <td>{{item.params.data.conTotal}}</td>
                <td style="font-weight: bold;">{{item.params.data.con_nota}}</td>
                <td style="font-weight: bold;">{{item.params.data.nota}}</td>
                        <td>
                            <div class="d-flex float-right">
                                <button ngbTooltip="Editar" (click)="open(editar, item)"
                                    class="btn btn-sm btn-primary ml-1 mr-1">
                                    <fa-icon [icon]="['fas','user-edit']"></fa-icon>
                                </button>
                                <button ngbTooltip="Descargar PDF"
                                    class="btn btn-sm btn-danger ml-1 mr-1" (click)="getPdf(item.fic_id)">
                                    <fa-icon [icon]="['fas','file-pdf']"></fa-icon>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<app-btn-scroll></app-btn-scroll>

<ng-template #editar let-modal>
    <app-edit-ficha [ficha]="ficha" [modal]="modal" (onSave)="updateFicha($event)"></app-edit-ficha>
</ng-template>